import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BehaviorSubject, Observable } from "rxjs";
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { UserTableService } from 'src/service/user.service';

import { CustomerService, FireForesightService, DistributionListService, MessageTemplateService } from 'src/api/services';
import { User,Customer, CustomerSummary, StatusType, Status, ResponsibleParty, DistributionList, MessageTemplate } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { Command } from 'src/api/models/command';
import { CommandParameter } from 'src/api/models/command-parameter';
import { FireForesightCameraConfigsComponent } from '../camera-configs/fire-foresight-camera-configs.component';
import { FireForesightSitesComponent } from '../sites/fire-foresight-sites.component';

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-fire-foresight-admin',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ModalModule,
    TabsModule,
    FireForesightCameraConfigsComponent,
    FireForesightSitesComponent
  ],
  templateUrl: './fire-foresight-admin.component.html',
  styleUrls: ['./fire-foresight-admin.component.css']
})
export class FireForesightAdminComponent implements OnInit {
  public displayName: string;
  public description: string;

  public newStatus : StatusType = {} as StatusType;
  public editStatus : StatusType = {} as StatusType;
  public list : StatusType [];
  
  public newResponsibleParty : ResponsibleParty = {} as ResponsibleParty;
  public editResponsibleParty : ResponsibleParty = {} as ResponsibleParty;
  public responsibleParties: ResponsibleParty[];
  
  // Distribution lists and templates for dropdowns
  public newDistributionLists: DistributionList[] = [];
  public newMessageTemplates: MessageTemplate[] = [];
  public editDistributionLists: DistributionList[] = [];
  public editMessageTemplates: MessageTemplate[] = [];
  
  // Validation tracking for new responsible party form
  public newRPTouched = {
    displayName: false,
    description: false,
    colour: false
  };
  
  // Validation tracking for edit responsible party form
  public editRPTouched = {
    displayName: false,
    description: false,
    colour: false
  };
  
  
  constructor(public app: ApplicationConfigService, private svc: FireForesightService, private toasterService: ToastrService, private customerService: CustomerService, private distributionListService: DistributionListService, private messageTemplateService: MessageTemplateService) { 
    // console.log("fire-foresight-admin constructor")
  }

  ngOnInit(): void {    
    this.svc.FireForesightGetStatusTypes().subscribe(r=>{
      console.log("ngOnInit", r);
      this.list = r;
      // {statusId: 1, displayName: 'Unconfirmed', description: 'Initial state for all detections'}
    });
    this.svc.FireForesightGetResponsibleParties(null).subscribe(r => {
      this.responsibleParties = r;
    });
    
  }

  public addStatus() {
    this.newStatus = {} as StatusType;  
  }
  
  public addResponsibleParty() {
    this.newResponsibleParty = {} as ResponsibleParty;
    this.newRPTouched = {
      displayName: false,
      description: false,
      colour: false
    };
    this.newDistributionLists = [];
    this.newMessageTemplates = [];
  }
  
  public onNewCustomerChange() {
    if (this.newResponsibleParty.customerId) {
      // Load distribution lists for selected customer
      this.distributionListService.DistributionListGetDistributionLists(this.newResponsibleParty.customerId).subscribe(lists => {
        this.newDistributionLists = lists;
      });
      // Load message templates for selected customer
      this.messageTemplateService.MessageTemplateGetMessageTemplates(this.newResponsibleParty.customerId).subscribe(templates => {
        this.newMessageTemplates = templates;
      });
    } else {
      this.newDistributionLists = [];
      this.newMessageTemplates = [];
      this.newResponsibleParty.distributionListId = null;
      this.newResponsibleParty.distributionTemplateId = null;
    }
  }
  
  public onEditCustomerChange() {
    if (this.editResponsibleParty.customerId) {
      // Load distribution lists for selected customer
      this.distributionListService.DistributionListGetDistributionLists(this.editResponsibleParty.customerId).subscribe(lists => {
        this.editDistributionLists = lists;
      });
      // Load message templates for selected customer
      this.messageTemplateService.MessageTemplateGetMessageTemplates(this.editResponsibleParty.customerId).subscribe(templates => {
        this.editMessageTemplates = templates;
      });
    } else {
      this.editDistributionLists = [];
      this.editMessageTemplates = [];
      this.editResponsibleParty.distributionListId = null;
      this.editResponsibleParty.distributionTemplateId = null;
    }
  }
  
  public isNewResponsiblePartyValid(): boolean {
    return !!(this.newResponsibleParty.displayName && 
              this.newResponsibleParty.description && 
              this.newResponsibleParty.colour);
  }
  
  public isEditResponsiblePartyValid(): boolean {
    return !!(this.editResponsibleParty.displayName && 
              this.editResponsibleParty.description && 
              this.editResponsibleParty.colour);
  }
  
  public markNewRPFieldTouched(field: string) {
    this.newRPTouched[field] = true;
  }
  
  public markEditRPFieldTouched(field: string) {
    this.editRPTouched[field] = true;
  }
  
  public openEditResponsiblePartyModal(item: ResponsibleParty) {
    this.editResponsibleParty = {...item};
    this.editRPTouched = {
      displayName: false,
      description: false,
      colour: false
    };
    
    // Load distribution lists and templates if customer is selected
    if (this.editResponsibleParty.customerId) {
      this.distributionListService.DistributionListGetDistributionLists(this.editResponsibleParty.customerId).subscribe(lists => {
        this.editDistributionLists = lists;
      });
      this.messageTemplateService.MessageTemplateGetMessageTemplates(this.editResponsibleParty.customerId).subscribe(templates => {
        this.editMessageTemplates = templates;
      });
    } else {
      this.editDistributionLists = [];
      this.editMessageTemplates = [];
    }
  }

  public saveNewItem() {
    var obj = {StatusId: 0, DisplayName: this.newStatus.displayName, Description: this.newStatus.description, Colour: this.newStatus.colour, Visible: this.newStatus.visible};
    this.svc.FireForesightAddStatus(obj).subscribe(c => {
      this.list.push(c);
      console.log("saveNewItem", c);
      this.toasterService.success("New Item Added");
    });
  }

  public removeStatus(Status) {
    let id = Status.statusId;

    this.svc.FireForesightRemoveStatus(id).subscribe(d => {
      this.ngOnInit();
      this.toasterService.success("Item Removed");
    });
  }

  public updateStatus(data) {
    var obj = {StatusId: data.statusId, DisplayName: data.displayName, Description: data.description, Colour: data.colour, Visible: data.visible};
    this.svc.FireForesightUpdateStatus(obj).subscribe(e => {
      this.ngOnInit();
      this.toasterService.success("  Item Updated");
    });
  }

  public saveNewResponsibleParty() {
    // Mark all fields as touched to show validation
    this.newRPTouched.displayName = true;
    this.newRPTouched.description = true;
    this.newRPTouched.colour = true;
    
    // Validate mandatory fields
    if (!this.isNewResponsiblePartyValid()) {
      this.toasterService.error("Display Name, Description, and Colour are required");
      return;
    }
    
    var obj = {ResponsiblePartyId: 0, DisplayName: this.newResponsibleParty.displayName, Description: this.newResponsibleParty.description, Colour: this.newResponsibleParty.colour, Visible: this.newResponsibleParty.visible, CustomerId: this.newResponsibleParty.customerId};
    this.svc.FireForesightAddResponsibleParty(obj).subscribe(c => {
      this.responsibleParties.push(c);
      console.log("saveNewResponsibleParty", c);
      this.toasterService.success("New Responsible Party Added");
    });
  }

  public removeResponsibleParty(Status) {
    let id = Status.statusId;

    this.svc.FireForesightRemoveResponsibleParty(id).subscribe(d => {
      this.ngOnInit();
      this.toasterService.success("Item Removed");
    });
  }

  public updateResponsibleParty(data) {
    // Mark all fields as touched to show validation
    this.editRPTouched.displayName = true;
    this.editRPTouched.description = true;
    this.editRPTouched.colour = true;
    
    // Validate mandatory fields
    if (!this.isEditResponsiblePartyValid()) {
      this.toasterService.error("Display Name, Description, and Colour are required");
      return;
    }
    
    
    var obj = {ResponsiblePartyId: data.responsiblePartyId, DisplayName: data.displayName, Description: data.description, Colour: data.colour, Visible: data.visible, CustomerId: data.customerId};
    this.svc.FireForesightUpdateResponsibleParty(obj).subscribe(e => {
      this.ngOnInit();
      this.toasterService.success("Item Updated");
    });
  }

}